import reducer from './reducers';
import * as confirmFlowsActions from './actions';
import * as confirmFlowsSelectors from './selectors';

export { confirmFlowsActions, confirmFlowsSelectors };
export default reducer;